const stagingPlanOptions = [
  {
    selling_plan: '691028984120',
    value: '1 Month(s)',
    frequency_number: '1'
  },
  {
    selling_plan: '691029016888',
    value: '2 Month(s)',
    frequency_number: '2'
  },
  {
    selling_plan: '691029049656',
    value: '3 Month(s)',
    frequency_number: '3'
  },
  {
    selling_plan: '694900359480',
    value: '4 Month(s)',
    frequency_number: '4'
  },
  {
    selling_plan: '693002731832',
    value: '6 Month(s)',
    frequency_number: '6'
  }
];

export default stagingPlanOptions;
